import { buildQueryString } from '@izimi/utils';

import type FetchService from '../FetchService';
import type { ApiNotification } from './types';

interface GetNotificationsParams {
  page: number;
  pageSize: number;
  from: string;
}

class NotificationsApi {
  constructor(private fetchService: FetchService) {}

  getNotifications({
    page,
    pageSize,
  }: Omit<GetNotificationsParams, 'from'>): Promise<ApiNotification[]>;
  getNotifications({ from }: Pick<GetNotificationsParams, 'from'>): Promise<ApiNotification[]>;

  getNotifications({ page, pageSize, from }: GetNotificationsParams) {
    const qs = buildQueryString({ from, page, pageSize });
    return this.fetchService.get<ApiNotification[]>(`/events/notifications${qs}`);
  }

  deleteNotification(notificationId: number) {
    return this.fetchService.delete<void>(`/notifications/${notificationId}`);
  }

  markNotificationsAsViewed(notificationIds: number[]) {
    return this.fetchService.put<void>('/notifications/view', notificationIds);
  }
}

export default NotificationsApi;
